import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import closeIcon from "../../../assets/icons/closeIcon.svg";
import { LeadFilterOptionsProps } from "./lead-filter.props";
import "./lead-filter.scss";
import AnnualRevenueFilter from "./lead-filter-options/annual-revenue-filter";
import EmailFilter from "./lead-filter-options/email-filter";
import FaxFilter from "./lead-filter-options/fax-filter";
import FirstNameFilter from "./lead-filter-options/first-name-filter";
import LastNameFilter from "./lead-filter-options/last-name-filter";
import CreatedByFilter from "./lead-filter-options/created-by-filter";
import CompanyFilter from "./lead-filter-options/company-filter";
import IndustryFilter from "./lead-filter-options/industry-filter";
import ConfidenceScoreFilter from "./lead-filter-options/confidence-score-filter";
import CreatedTimeFilter from "./lead-filter-options/created-time-filter";
import LastActivityTimeFilter from "./lead-filter-options/last-activity-time-filter";
import CityFilter from "./lead-filter-options/city-filter";
import CountryFilter from "./lead-filter-options/country-filter";
import dayjs, { Dayjs } from "dayjs";
import { isOnlyCountryCode } from "../../../utils/utils";
import LeadOwnerFilter from "./lead-filter-options/lead-owner-filter";
import AssignedPartnerFilter from "./lead-filter-options/assigned-partner-filter";
import LeadStatusFilter from "./lead-filter-options/lead-status-filter";

const LeadFilterOptions: React.FC<LeadFilterOptionsProps> = (props: any) => {
  const {
    setSelectedLeadsFilters,
    setIsOpenFilter,
    isOpenFilter,
    selectedLeadsFilterOptions,
    setSelectedLeadsFilterOptions,
    onApplyFilters,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    isAssign = true,
    activeFilters
  } = props;
  const [annualRevenueRange, setAnnualRevenueRange] = useState({
    min: "",
    max: "",
  });
  const [minValueError, setMinValueError] = useState("");
  const [maxValueError, setMaxValueError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [fax, setFax] = useState("");
  const [faxError, setFaxError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [company, setCompany] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [industry, setIndustry] = useState("");
  const [industryError, setIndustryError] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState("");
  const [confidenceScore, setConfidenceScore] = useState<string[]>([]);
  const [confidenceScoreError, setConfidenceScoreError] = useState("");
  const [leadStatusError, setLeadStatusError] = useState("");
  const [createdTime, setCreatedTime] = useState<string>("");
  const [createdTimeError, setCreatedTimeError] = useState("");
  const [createdTimeStart, setCreatedTimeStart] = useState<Dayjs | null>(null);
  const [createdTimeEnd, setCreatedTimeEnd] = useState<Dayjs | null>(null);
  const [createdTimeStartError, setCreatedTimeStartError] = useState("");
  const [createdTimeEndError, setCreatedTimeEndError] = useState("");
  const [createdByUserIds, setCreatedByUserIds] = useState<number[]>([]);
  const [createdByUserIdsError, setCreatedByUserIdsError] = useState("");
  const [leadOwnerIds, setLeadOwnerIds] = useState<number[]>([]);
  const [leadOwnerIdsError, setLeadOwnerIdsError] = useState("");
  const [assignedPartnerIds, setAssignedPartnerIds] = useState<number[]>([]);
  const [assignedPartnerIdsError, setAssignedPartnerIdsError] = useState("");
  const [lastActivityTime, setLastActivityTime] = useState<string>("");
  const [lastActivityTimeError, setLastActivityTimeError] = useState("");
  const [lastActivityTimeStart, setLastActivityTimeStart] = useState<Dayjs | null>(null);
  const [lastActivityTimeEnd, setLastActivityTimeEnd] = useState<Dayjs | null>(null);
  const [lastActivityTimeStartError, setLastActivityTimeStartError] = useState("");
  const [lastActivityTimeEndError, setLastActivityTimeEndError] = useState("");
  const [status, setStatus] = useState<string[]>([]);
  const [draftSelectedLeadsFilterOptions, setDraftSelectedLeadsFilterOptions] =
    useState<any[]>([]);
  useEffect(() => {
    if (isOpenFilter) {
      const updatedDraft = selectedLeadsFilterOptions.map((option: any) => {
        switch (option.label) {
          case "Assigned Partner":
            return {
              ...option,
              value: !!(activeFilters?.assignedPartnerIds?.length),
            };
          case "Lead Value":
            return {
              ...option,
              value: !!(
                activeFilters?.annualRevenueRange?.min ||
                activeFilters?.annualRevenueRange?.max
              ),
            };
          case "Confidence Score":
            return {
              ...option,
              value: !!activeFilters?.confidenceScore,
            };
          case "City":
            return {
              ...option,
              value: !!activeFilters?.city,
            };
          case "Created By":
            return {
              ...option,
              value: !!(activeFilters?.createdByUserIds?.length),
            };
          case "Created Time":
            return {
              ...option,
              value: !!(activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd),
            };
          case "Fax":
            return {
              ...option,
              value: !!activeFilters?.fax,
            };
          case "Lead Owner":
            return {
              ...option,
              value: !!(activeFilters?.leadOwner?.length),
            };
          case "Lead Status":
            return {
              ...option,
              value: !!activeFilters?.leadStatus,
            };
          case "Industry":
            return {
              ...option,
              value: !!activeFilters?.industry,
            };
          case "Last Activity Time":
            return {
              ...option,
              value: !!(activeFilters?.lastActivityTimeStart && activeFilters?.lastActivityTimeEnd),
            };
          case "Country":
            return {
              ...option,
              value: !!activeFilters?.country,
            };
          case "Email":
            return {
              ...option,
              value: !!activeFilters?.email,
            };
          case "First Name":
            return {
              ...option,
              value: !!activeFilters?.firstName,
            };
          case "Last Name":
            return {
              ...option,
              value: !!activeFilters?.lastName,
            };
          default:
            return option;
        }
      });
      setDraftSelectedLeadsFilterOptions(updatedDraft);
      if (activeFilters?.assignedPartnerIds?.length) {
        setAssignedPartnerIds(activeFilters.assignedPartnerIds);
      }
      if (activeFilters?.annualRevenueRange) {
        setAnnualRevenueRange(activeFilters.annualRevenueRange);
      }
      if (activeFilters?.city) {
        setCity(activeFilters.city);
      }
      if (activeFilters?.fax) {
        setFax(activeFilters.fax);
      }

      if (activeFilters?.leadOwnerIds) {
        setLeadOwnerIds(activeFilters.leadOwnerIds);
      }

      if (activeFilters?.leadStatus?.length) {
        setStatus(activeFilters.leadStatus);
      }
      if (activeFilters?.industry) {
        setIndustry(activeFilters.industry);
      }
      if (activeFilters?.country) {
        setCountry(activeFilters.country);
      }

      if (activeFilters?.email) {
        setEmail(activeFilters.email);
      }

      if (activeFilters?.firstName) {
        setFirstName(activeFilters.firstName);
      }

      if (activeFilters?.lastName) {
        setLastName(activeFilters.lastName);
      }
      if (activeFilters?.confidenceScore) {
        setConfidenceScore(activeFilters.confidenceScore);
      }
      if (activeFilters?.createdByUserIds?.length) {
        setCreatedByUserIds(activeFilters.createdByUserIds);
      }
      if (activeFilters?.createdTimeStart && activeFilters?.createdTimeEnd) {
        const start = dayjs(activeFilters.createdTimeStart);
        const end = dayjs(activeFilters.createdTimeEnd);

        const match = (a: dayjs.Dayjs, b: dayjs.Dayjs) => a.isSame(b, "second");

        if (
          match(start, dayjs().startOf("day")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("Today");
        } else if (
          match(start, dayjs().subtract(1, "day").startOf("day")) &&
          match(end, dayjs().subtract(1, "day").endOf("day"))
        ) {
          setCreatedTime("Yesterday");
        } else if (
          match(start, dayjs().startOf("week")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("This Week");
        } else if (
          match(start, dayjs().startOf("month")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setCreatedTime("This Month");
        } else if (
          match(start, dayjs().subtract(1, "week").startOf("week").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "week").endOf("week").hour(23).minute(59).second(0))
        ) {
          setCreatedTime("Last Week");
        } else if (
          match(start, dayjs().subtract(1, "month").startOf("month").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "month").endOf("month").hour(23).minute(59).second(0))
        ) {
          setCreatedTime("Last Month");
        } else {
          setCreatedTime("Custom");
          setCreatedTimeStart(start);
          setCreatedTimeEnd(end);
        }
      }
      if (activeFilters?.lastActivityTimeStart && activeFilters?.lastActivityTimeEnd) {
        const start = dayjs(activeFilters.lastActivityTimeStart);
        const end = dayjs(activeFilters.lastActivityTimeEnd);

        const match = (a: dayjs.Dayjs, b: dayjs.Dayjs) => a.isSame(b, "second");

        if (
          match(start, dayjs().startOf("day")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastActivityTime("Today");
        } else if (
          match(start, dayjs().subtract(1, "day").startOf("day")) &&
          match(end, dayjs().subtract(1, "day").endOf("day"))
        ) {
          setLastActivityTime("Yesterday");
        } else if (
          match(start, dayjs().startOf("week")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastActivityTime("This Week");
        } else if (
          match(start, dayjs().startOf("month")) &&
          match(end, dayjs().endOf("day"))
        ) {
          setLastActivityTime("This Month");
        } else if (
          match(start, dayjs().subtract(1, "week").startOf("week").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "week").endOf("week").hour(23).minute(59).second(0))
        ) {
          setLastActivityTime("Last Week");
        } else if (
          match(start, dayjs().subtract(1, "month").startOf("month").hour(0).minute(0).second(0)) &&
          match(end, dayjs().subtract(1, "month").endOf("month").hour(23).minute(59).second(0))
        ) {
          setLastActivityTime("Last Month");
        } else {
          setLastActivityTime("Custom");
          setLastActivityTimeStart(start);
          setLastActivityTimeEnd(end);
        }
      }
    }
  }, [isOpenFilter]);
  const isAnyFilterSelected = draftSelectedLeadsFilterOptions.some(
    (option: any) => option.value
  );
  const handleChange = (e: any) => {
    // const tempSelectedLeadsFilterOptions = selectedLeadsFilterOptions?.map(
    //   (data: any) => {
    //     return data?.labels === e.target.id
    //       ? { ...data, value: !data?.value }
    //       : data;
    //   },
    // );
    const updatedDraft = draftSelectedLeadsFilterOptions.map((data: any) =>
      data?.labels === e.target.id ? { ...data, value: !data?.value } : data
    );
    const isAnnualRevenueUnchecked = e.target.id === "Lead Value" && !e.target.checked;
    if (isAnnualRevenueUnchecked) {
      setAnnualRevenueRange({ min: "", max: "" });
      setMinValueError("");
      setMaxValueError("");
    }
    const isAnnualRevenueChecked = e.target.id === "Lead Value" && e.target.checked;
    if (isAnnualRevenueChecked) {
      setMinValueError("");
      setMaxValueError("");
    }
    
    const isEmailUnchecked = e.target.id === "Email" && !e.target.checked;
    if (isEmailUnchecked) {
      setEmail("");
      setEmailError("");
    }
    const isEmailChecked = e.target.id === "Email" && e.target.checked;
    if (isEmailChecked) {
      setEmailError("");
    }
    
    const isFirstNameUnchecked = e.target.id === "First Name" && !e.target.checked;
    if (isFirstNameUnchecked) {
      setFirstName("");
      setFirstNameError("");
    }
    const isFirstNameChecked = e.target.id === "First Name" && e.target.checked;
    if (isFirstNameChecked) {
      setFirstNameError("");
    }
    
    const isLastNameUnchecked = e.target.id === "Last Name" && !e.target.checked;
    if (isLastNameUnchecked) {
      setLastName("");
      setLastNameError("");
    }
    const isLastNameChecked = e.target.id === "Last Name" && e.target.checked;
    if (isLastNameChecked) {
      setLastNameError("");
    }
    
    const isCompanyUnchecked = e.target.id === "Company" && !e.target.checked;
    if (isCompanyUnchecked) {
      setCompany("");
      setCompanyError("")
    }
    const isCompanyChecked = e.target.id === "Company" && e.target.checked;
    if (isCompanyChecked) {
      setCompanyError("");
    }
    
    const isIndustryUnchecked = e.target.id === "Industry" && !e.target.checked;
    if (isIndustryUnchecked) {
      setIndustry("");
      setIndustryError("");
    }
    const isIndustryChecked = e.target.id === "Industry" && e.target.checked;
    if (isIndustryChecked) {
      setIndustryError("");
    }
    
    const isCityUnchecked = e.target.id === "City" && !e.target.checked;
    if (isCityUnchecked) {
      setCity("");
      setCityError("");
    }
    const isCityChecked = e.target.id === "City" && e.target.checked;
    if (isCityChecked) {
      setCityError("");
    }
    
    const isCountryUnchecked = e.target.id === "Country" && !e.target.checked;
    if (isCountryUnchecked) {
      setCountry("");
      setCountryError("");
    }
    const isCountryChecked = e.target.id === "Country" && e.target.checked;
    if (isCountryChecked) {
      setCountryError("");
    }
    
    const isFaxUnchecked = e.target.id === "Fax" && !e.target.checked;
    if (isFaxUnchecked) {
      setFax("");
      setFaxError("");
    }
    const isFaxChecked = e.target.id === "Fax" && e.target.checked;
    if (isFaxChecked) {
      setFaxError("");
    }
    const isCreatedByUnchecked = e.target.id === "Created By" && !e.target.checked;
    if (isCreatedByUnchecked) {
      setCreatedByUserIds([]);
      setCreatedByUserIdsError("");
    }
    const isCreatedByChecked = e.target.id === "Created By" && e.target.checked;
    if (isCreatedByChecked) {
      setCreatedByUserIdsError("");
    }
    
    const isLeadOwnerUnchecked = e.target.id === "Lead Owner" && !e.target.checked;
    if (isLeadOwnerUnchecked) {
      setLeadOwnerIds([]);
      setLeadOwnerIdsError("");
    }
    const isLeadOwnerChecked = e.target.id === "Lead Owner" && e.target.checked;
    if (isLeadOwnerChecked) {
      setLeadOwnerIdsError("");
    }
    
    const isAssignedPartnerUnchecked = e.target.id === "Assigned Partner" && !e.target.checked;
    if (isAssignedPartnerUnchecked) {
      setAssignedPartnerIds([]);
      setAssignedPartnerIdsError("");
    }
    const isAssignedPartnerChecked = e.target.id === "Assigned Partner" && e.target.checked;
    if (isAssignedPartnerChecked) {
      setAssignedPartnerIdsError("");
    }
    
    const isCreatedTimeUnchecked = e.target.id === "Created Time" && !e.target.checked;
    if (isCreatedTimeUnchecked) {
      setCreatedTime("");
      setCreatedTimeStart(null);
      setCreatedTimeEnd(null);
      setCreatedTimeError("");
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
    const isCreatedTimeChecked = e.target.id === "Created Time" && e.target.checked;
    if (isCreatedTimeChecked) {
      setCreatedTimeError("");
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
    
    const isLastActivityTimeUnchecked = e.target.id === "Last Activity Time" && !e.target.checked;
    if (isLastActivityTimeUnchecked) {
      setLastActivityTime("")
      setLastActivityTimeStart(null);
      setLastActivityTimeEnd(null);
      setLastActivityTimeError("");
      setLastActivityTimeStartError("");
      setLastActivityTimeEndError("");
    }
    const isLastActivityTimeChecked = e.target.id === "Last Activity Time" && e.target.checked;
    if (isLastActivityTimeChecked) {
      setLastActivityTimeError("");
      setLastActivityTimeStartError("");
      setLastActivityTimeEndError("");
    }
    
    const isConfidenceScoreUnchecked = e.target.id === "Confidence Score" && !e.target.checked;
    if (isConfidenceScoreUnchecked) {
      setConfidenceScore([]);
      setConfidenceScoreError("");
    }
    const isConfidenceScoreChecked = e.target.id === "Confidence Score" && e.target.checked;
    if (isConfidenceScoreChecked) {
      setConfidenceScoreError("");
    }
    
    const isLeadStatusUnchecked = e.target.id === "Lead Status" && !e.target.checked;
    if (isLeadStatusUnchecked) {
      setStatus([]);
      setLeadStatusError("");
    }
    const isLeadStatusChecked = e.target.id === "Lead Status" && e.target.checked;
    if (isLeadStatusChecked) {
      setLeadStatusError("");
    }
    setDraftSelectedLeadsFilterOptions(updatedDraft);
    // setSelectedLeadsFilters(
    //   tempSelectedLeadsFilterOptions?.filter((data: any) => {
    //     return data?.value;
    //   }),
    // );
  };
  const handleReset = () => {
    const resetFilters = selectedLeadsFilterOptions.map((option: any) => ({
      ...option,
      value: false,
    }));

    setSelectedLeadsFilterOptions(resetFilters);
    setDraftSelectedLeadsFilterOptions(resetFilters);

    setSelectedLeadsFilterOptions(resetFilters);
    setAnnualRevenueRange({ min: "", max: "" });
    setMinValueError("");
    setMaxValueError("");
    setCity("");
    setCityError("");
    setCompany("");
    setCompanyError("");
    setIndustry("");
    setIndustryError("");
    setCountry("");
    setCountryError("");
    setEmail("");
    setEmailError("");
    setFax("");
    setFaxError("");
    setFirstName("");
    setFirstNameError("");
    setLastName("");
    setLastNameError("");
    setLastActivityTime("");
    setLastActivityTimeError("");
    setLastActivityTimeStart(null);
    setLastActivityTimeEnd(null);
    setLastActivityTimeStartError("");
    setLastActivityTimeEndError("");
    setCreatedTimeStart(null);
    setCreatedTimeEnd(null);
    setCreatedTimeStartError("");
    setCreatedTimeEndError("");
    setCreatedTime("");
    setCreatedTimeError("");
    setCreatedByUserIds([])
    setConfidenceScore([]);
    setConfidenceScoreError("");
    setStatus([]);
    setLeadStatusError("");
    setCreatedByUserIdsError("");
    setLeadOwnerIds([]);
    setLeadOwnerIdsError("");
    setAssignedPartnerIds([]);
    setAssignedPartnerIdsError("");
    setSelectedLeadsFilters([]);
    props.onApplyFilters({});
    setIsOpenFilter(false);
  };
  const handleAnnualRevenueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    if (e.target instanceof HTMLInputElement) {
      const value = e.target.value;
      const updatedRange = {
        ...annualRevenueRange,
        [field]: value,
      };
      setAnnualRevenueRange(updatedRange);
      if (field === "min" && value.trim()) {
        setMinValueError("");
      }
      if (field === "max" && value.trim()) {
        setMaxValueError("");
      }
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (value.trim() !== "") {
      setEmailError("");
    }
  };
  const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCity(value);
    if (value.trim() !== "") {
      setCityError("");
    }
  };
  const handleCountryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCountry(value);
    if (value.trim() !== "") {
      setCountryError("");
    }
  };
  const handleFaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFax(value);
    if (value.trim() !== "") {
      setFaxError("");
    }
  };
  const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFirstName(value);
    if (value.trim() !== "") {
      setFirstNameError("");
    }
  };
  const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLastName(value);
    if (value.trim() !== "") {
      setLastNameError("");
    }
  };
  const handleCompanyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCompany(value);
    if (value.trim() !== "") {
      setCompanyError("");
    }
  };
  const handleIndustryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setIndustry(value);
    if (value.trim() !== "") {
      setIndustryError("");
    }
  };
  const handleConfidenceScoreChange = (value: string[]) => {
    setConfidenceScore(value);
    const hasValidValue = value.some((val) => val.trim() !== "");

    if (hasValidValue) {
      setConfidenceScoreError("");
    }
  };
  const handleLeadStatusChange = (value: string[]) => {
    setStatus(value);
    const hasValidValue = value.some((val) => val.trim() !== "");

    if (hasValidValue) {
      setLeadStatusError("");
    }
  };
  const handleCreatedTimeChange = (value: string) => {
    setCreatedTime(value);

    if (value.length > 0) {
      setCreatedTimeError("");
    }
    if (!value.includes("Custom")) {
      setCreatedTimeStart(null);
      setCreatedTimeEnd(null);
      setCreatedTimeStartError("");
      setCreatedTimeEndError("");
    }
  };

  const handleLastActivityTimeChange = (value: string) => {
    setLastActivityTime(value);
    if (value.length > 0) {
      setLastActivityTimeError("");
    }
    if (!value.includes("Custom")) {
      setLastActivityTimeStart(null);
      setLastActivityTimeEnd(null);
      setLastActivityTimeStartError("");
      setLastActivityTimeEndError("")
    }
  };
  const handleCreatedByChange = (selectedIds: number[]) => {
    setCreatedByUserIds(selectedIds);

    if (selectedIds.length > 0) {
      setCreatedByUserIdsError("");
    }
  };
  const handleLeadOwnerChange = (selectedIds: number[]) => {
    setLeadOwnerIds(selectedIds);

    if (selectedIds.length > 0) {
      setLeadOwnerIdsError("");
    }
  };
  const handleAssignedPartnerChange = (selectedIds: number[]) => {
    setAssignedPartnerIds(selectedIds);

    if (selectedIds.length > 0) {
      setAssignedPartnerIdsError("");
    }
  };
  const handleCreatedTimeDateRange = (from: Date | null, to: Date | null) => {
    setCreatedTimeStart(from ? dayjs(from) : null);
    setCreatedTimeEnd(to ? dayjs(to) : null);

    if (from) setCreatedTimeStartError("");
    if (to) setCreatedTimeEndError("");
  };


  const handleLastActivityTimeDateRange = (from: Date | null, to: Date | null) => {
    setLastActivityTimeStart(from ? dayjs(from) : null);
    setLastActivityTimeEnd(to ? dayjs(to) : null);

    if (from) setLastActivityTimeStartError("");
    if (to) setLastActivityTimeEndError("");
  };
  const isEmailEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Email"
  )?.value;
  const isAnnualRevenueEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Lead Value"
  )?.value;
  const isCityEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "City"
  )?.value;
  const isCountryEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Country"
  )?.value;
  const isFaxEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Fax"
  )?.value;
  const isFirstNameEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "First Name"
  )?.value;
  const isLastNameEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Last Name"
  )?.value;
  const isCompanyEnabled = selectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Company"
  )?.value;
  const isIndustryEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Industry"
  )?.value;
  const isConfidenceScoreEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Confidence Score"
  )?.value;
  const isCreatedTimeEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created Time"
  )?.value;
  const isLastActivityTimeEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Last Activity Time"
  )?.value;
  const isCreatedByEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Created By"
  )?.value;
  const isLeadOwnerEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Lead Owner"
  )?.value;
  const isLeadStatusEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Lead Status"
  )?.value;
  const isAssignedPartnerEnabled = draftSelectedLeadsFilterOptions.find(
    (opt: any) => opt.labels === "Assigned Partner"
  )?.value;
  const renderFilterField = (optionLabel: string) => {
    switch (optionLabel) {
      case "Lead Value":
        return (
          <AnnualRevenueFilter
            annualRevenueRange={annualRevenueRange}
            handleAnnualRevenueChange={handleAnnualRevenueChange}
            isAnnualRevenueEnabled={isAnnualRevenueEnabled}
            minValueError={minValueError}
            maxValueError={maxValueError}
          />
        );
      case "Email":
        return (
          <EmailFilter
            email={email}
            handleEmailChange={handleEmailChange}
            isEmailEnabled={isEmailEnabled}
            emailError={emailError}
          />
        );
      case "City":
        return (
          <CityFilter
            city={city}
            handleCityChange={handleCityChange}
            isCityEnabled={isCityEnabled}
            cityError={cityError}
          />
        );
      case "Country":
        return (
          <CountryFilter
            country={country}
            handleCountryChange={handleCountryChange}
            isCountryEnabled={isCountryEnabled}
            countryError={countryError}
          />
        );
      case "Fax":
        return (
          <FaxFilter
            fax={fax}
            handleFaxChange={handleFaxChange}
            isFaxEnabled={isFaxEnabled}
            faxError={faxError}
          />
        );
      case "First Name":
        return (
          <FirstNameFilter
            firstName={firstName}
            handleFirstNameChange={handleFirstNameChange}
            isFirstNameEnabled={isFirstNameEnabled}
            firstNameError={firstNameError}
          />
        );
      case "Last Name":
        return (
          <LastNameFilter
            lastName={lastName}
            handleLastNameChange={handleLastNameChange}
            isLastNameEnabled={isLastNameEnabled}
            lastNameError={lastNameError}
          />
        );
      case "Company":
        return (
          <CompanyFilter
            comapny={company}
            handleCompanyChange={handleCompanyChange}
            isCompanyEnabled={isCompanyEnabled}
            companyError={companyError}
          />
        );
      case "Industry":
        return (
          <IndustryFilter
            industry={industry}
            handleIndustryChange={handleIndustryChange}
            isIndustryEnabled={isIndustryEnabled}
            industryError={industryError}
          />
        );
      case "Confidence Score":
        return (
          < ConfidenceScoreFilter
            value={confidenceScore}
            onChange={handleConfidenceScoreChange}
            isConfidenceScoreEnabled={isConfidenceScoreEnabled}
            confidenceScoreError={confidenceScoreError}
          />
        );
      case "Lead Status":
        return (
          < LeadStatusFilter
            value={status}
            onChange={handleLeadStatusChange}
            isLeadStatusEnabled={isLeadStatusEnabled}
            leadStatusError={leadStatusError}
          />
        );
      case "Created Time":
        return (
          <CreatedTimeFilter
            value={createdTime}
            onChange={handleCreatedTimeChange}
            isCreatedTimeEnabled={isCreatedTimeEnabled}
            onDateRangeChange={handleCreatedTimeDateRange}
            createdTimeError={createdTimeError}
            createdTimeStartError={createdTimeStartError}
            createdTimeEndError={createdTimeEndError}
            setCreatedTimeFromDate={setCreatedTimeStart}
            setCretedTimeToDate={setCreatedTimeEnd}
          />
        );
      case "Last Activity Time":
        return (
          <LastActivityTimeFilter
            value={lastActivityTime}
            onChange={handleLastActivityTimeChange}
            isLastActivityTimeEnabled={isLastActivityTimeEnabled}
            onDateRangeChange={handleLastActivityTimeDateRange}
            lastActivityTimeError={lastActivityTimeError}
            lastActivityTimeStartError={lastActivityTimeStartError}
            lastActivityTimeEndError={lastActivityTimeEndError}
            setLastActivityFromDate={setLastActivityTimeStart}
            setLastActivityToDate={setLastActivityTimeEnd}
          />
        );
      case "Created By":
        return (
          <CreatedByFilter
            value={createdByUserIds}
            onChange={handleCreatedByChange}
            isCreatedByEnabled={isCreatedByEnabled}
            createdByUserIdsError={createdByUserIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      case "Lead Owner":
        return (
          <LeadOwnerFilter
            value={leadOwnerIds}
            onChange={handleLeadOwnerChange}
            isLeadOwnerEnabled={isLeadOwnerEnabled}
            leadOwnerIdsError={leadOwnerIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      case "Assigned Partner":
        if (!isAssign) return null;
        return (
          <AssignedPartnerFilter
            value={assignedPartnerIds}
            onChange={handleAssignedPartnerChange}
            isAssignedPartnerEnabled={isAssignedPartnerEnabled}
            assignedPartnerIdsError={assignedPartnerIdsError}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        );
      default:
        return null;
    }
  };
  const handleApplyFilters = () => {
    let hasError = false;
    if (isEmailEnabled && !email.trim()) {
      setEmailError("Enter Email");
      hasError = true;
    } else {
      setEmailError("");
    }
    if (isCityEnabled && !city.trim()) {
      setCityError("Enter City");
      hasError = true;
    } else {
      setCityError("");
    }
    if (isCountryEnabled && !country.trim()) {
      setCountryError("Enter Country");
      hasError = true;
    } else {
      setCountryError("");
    }
    if (isFaxEnabled && (!fax.trim() || isOnlyCountryCode(fax))) {
      setFaxError("Enter Fax");
      hasError = true;
    } else {
      setFaxError("");
    }
    if (isFirstNameEnabled && !firstName.trim()) {
      setFirstNameError("Enter First Name");
      hasError = true;
    } else {
      setFirstNameError("");
    }
    if (isLastNameEnabled && !lastName.trim()) {
      setLastNameError("Enter Last Name");
      hasError = true;
    } else {
      setLastNameError("");
    }
    if (isCompanyEnabled && !company.trim()) {
      setCompanyError("Enter Company");
      hasError = true;
    } else {
      setCompanyError("");
    }
    if (isIndustryEnabled && !industry.trim()) {
      setIndustryError("Enter Industry");
      hasError = true;
    } else {
      setIndustryError("");
    }
    if (
      isConfidenceScoreEnabled &&
      (confidenceScore.length === 0 || confidenceScore.every((val) => val.trim() === ""))
    ) {
      setConfidenceScoreError("Select Confidence Score");
      hasError = true;
    } else {
      setConfidenceScoreError("");
    }
    if (
      isLeadStatusEnabled &&
      (status.length === 0 || status.every((val) => val.trim() === ""))
    ) {
      setLeadStatusError("Select Lead Status");
      hasError = true;
    } else {
      setLeadStatusError("");
    }
    if (isCreatedByEnabled && createdByUserIds.length === 0) {
      setCreatedByUserIdsError("Select Created By");
      hasError = true;
    } else {
      setCreatedByUserIdsError("");
    }
    if (isLeadOwnerEnabled && leadOwnerIds.length === 0) {
      setLeadOwnerIdsError("Select Lead Owner");
      hasError = true;
    } else {
      setLeadOwnerIdsError("");
    } if (isAssignedPartnerEnabled && assignedPartnerIds.length === 0) {
      setAssignedPartnerIdsError("Select Assigned Partner");
      hasError = true;
    } else {
      setAssignedPartnerIdsError("");
    }
    if (isAnnualRevenueEnabled) {
      if (!annualRevenueRange.min.trim()) {
        setMinValueError("Enter Min Value");
        hasError = true;
      } else {
        setMinValueError("");
      }

      if (!annualRevenueRange.max.trim()) {
        setMaxValueError("Enter Max Value");
        hasError = true;
      } else {
        setMaxValueError("");
      }

      if (
        annualRevenueRange.min.trim() &&
        annualRevenueRange.max.trim() &&
        !isNaN(Number(annualRevenueRange.min)) &&
        !isNaN(Number(annualRevenueRange.max)) &&
        Number(annualRevenueRange.min) > Number(annualRevenueRange.max)
      ) {
        setMinValueError("Min value cannot be greater than Max value");
        setMaxValueError("Max value cannot be less than Min value");
        hasError = true;
      }
    } else {
      setMinValueError("");
      setMaxValueError("");
    }

    if (isCreatedTimeEnabled) {
      if (createdTime.length === 0) {
        setCreatedTimeError("Select Created Time");
        hasError = true;
      } else {
        setCreatedTimeError("");
      }
      if (createdTime.includes("Custom")) {
        if (!createdTimeStart) {
          setCreatedTimeStartError("Start date is required");
          hasError = true;
        } else if (!dayjs(createdTimeStart).isValid() ||
          dayjs(createdTimeStart).year() < 1900) {
          setCreatedTimeStartError("Invalid date");
          hasError = true;
        } else {
          setCreatedTimeStartError("");
        }

        if (!createdTimeEnd) {
          setCreatedTimeEndError("End date is required");
          hasError = true;
        } else if (!dayjs(createdTimeEnd).isValid() ||
          dayjs(createdTimeEnd).year() < 1900) {
          setCreatedTimeEndError("Invalid date");
          hasError = true;
        } else {
          setCreatedTimeEndError("");
        }
        if (
          createdTimeStart &&
          createdTimeEnd &&
          dayjs(createdTimeStart).isValid() &&
          dayjs(createdTimeEnd).isValid() &&
          dayjs(createdTimeStart).isAfter(dayjs(createdTimeEnd))
        ) {
          setCreatedTimeStartError("Start date cannot be greater than end date");
          setCreatedTimeEndError("End date cannot be less than start date");
          hasError = true;
        }
      } else {
        setCreatedTimeStartError("");
        setCreatedTimeEndError("");
      }
    }

    if (isLastActivityTimeEnabled) {
      if (lastActivityTime.length === 0) {
        setLastActivityTimeError("Select Last Activity Time");
        hasError = true;
      } else {
        setLastActivityTimeError("");
      }

      if (lastActivityTime.includes("Custom")) {
        if (!lastActivityTimeStart) {
          setLastActivityTimeStartError("Start date is required");
          hasError = true;
        } else if (!dayjs(lastActivityTimeStart).isValid() ||
          dayjs(lastActivityTimeStart).year() < 1900) {
          setLastActivityTimeStartError("Invalid date");
          hasError = true;
        } else {
          setLastActivityTimeStartError("");
        }

        if (!lastActivityTimeEnd) {
          setLastActivityTimeEndError("End date is required");
          hasError = true;
        } else if (!dayjs(lastActivityTimeEnd).isValid() ||
          dayjs(lastActivityTimeEnd).year() < 1900) {
          setLastActivityTimeEndError("Invalid date")
          hasError = true;
        } else {
          setLastActivityTimeEndError("");
        }
        if (
          lastActivityTimeStart &&
          lastActivityTimeEnd &&
          dayjs(lastActivityTimeStart).isValid() &&
          dayjs(lastActivityTimeEnd).isValid() &&
          dayjs(lastActivityTimeStart).isAfter(dayjs(lastActivityTimeEnd))
        ) {
          setLastActivityTimeStartError("Start date cannot be greater than end date");
          setLastActivityTimeEndError("End date cannot be lesser than start date");
          hasError = true;
        }
      } else {
        setLastActivityTimeStartError("");
        setLastActivityTimeEndError("");
      }
    }
    if (hasError) {
      return;
    }
    const filtersToApply: any = {};

    if (
      isAnnualRevenueEnabled &&
      (annualRevenueRange.min.trim() || annualRevenueRange.max.trim())
    ) {
      filtersToApply.annualRevenueRange = annualRevenueRange;
    }
    if (isEmailEnabled && email.trim()) filtersToApply.email = email;
    if (isCityEnabled && city.trim()) filtersToApply.city = city;
    if (isCountryEnabled && country.trim()) filtersToApply.country = country;
    if (isFaxEnabled && fax.trim()) filtersToApply.fax = fax;
    if (isFirstNameEnabled && firstName.trim()) filtersToApply.firstName = firstName;
    if (isLastNameEnabled && lastName.trim()) filtersToApply.lastName = lastName;
    if (isCompanyEnabled && company.trim()) filtersToApply.company = company;
    if (isIndustryEnabled && industry.trim()) filtersToApply.industry = industry;
    if (isConfidenceScoreEnabled && confidenceScore.length > 0) {
      filtersToApply.confidenceScore = confidenceScore;
    }
    if (isCreatedTimeEnabled && createdTimeStart && createdTimeEnd) {
      filtersToApply.createdTimeStart = createdTimeStart;
      filtersToApply.createdTimeEnd = createdTimeEnd;
    }
    if (isLastActivityTimeEnabled && lastActivityTimeStart && lastActivityTimeEnd) {
      filtersToApply.lastActivityTimeStart = lastActivityTimeStart;
      filtersToApply.lastActivityTimeEnd = lastActivityTimeEnd;
    }
    if (isCreatedByEnabled && createdByUserIds.length > 0) {
      filtersToApply.createdByUserIds = createdByUserIds;
    }
    if (isLeadOwnerEnabled && leadOwnerIds.length > 0) {
      filtersToApply.leadOwnerIds = leadOwnerIds;
    }
    if (isAssignedPartnerEnabled && assignedPartnerIds.length > 0) {
      filtersToApply.assignedPartnerIds = assignedPartnerIds;
    }
    if (isLeadStatusEnabled && status.length > 0) {
      filtersToApply.leadStatus = status;
    }

    onApplyFilters(filtersToApply);
    setSelectedLeadsFilterOptions(draftSelectedLeadsFilterOptions);
    setSelectedLeadsFilters(
      draftSelectedLeadsFilterOptions.filter((data: any) => data.value)
    );
    setIsOpenFilter(false);
  };
  return (
    <div className="lead-filter-options-wrapper">
      <div className="lead-filter-options-container">
        <div className="header-wrapper">
          <div className="lead-filter-options-container-header">
            <div className="lead-filter-options-container-header-text">
              Filters
            </div>
            <div className="lead-filter-options-container-header-icon">
              <img
                src={closeIcon}
                alt="Filter Icon"
                onClick={() => setIsOpenFilter(!isOpenFilter)}
              />
            </div>
          </div>
          <div className="lead-filter-options-container-subtext">
            Filter By Fields
          </div>
        </div>
        <div className="lead-filter-options-container-list">
          {draftSelectedLeadsFilterOptions
            .filter((option: any) => isAssign ? true : option.labels !== "Assigned Partner" && option.labels !== "Lead Status")
            .map((option: any) => (
              <div key={option.labels}>
                <label htmlFor={option.labels} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <Checkbox
                    checked={option?.value}
                    onChange={handleChange}
                    id={option.labels}
                  />
                  <ListItemText primary={option.labels} />
                </label>
                {option?.value && renderFilterField(option.labels)}
              </div>
            ))}
          {isAnyFilterSelected && (
            <div className="lead-filter-buttons">
              <button className="cancel-button" onClick={() => {
                handleReset();
              }}
              >
                Reset
              </button>
              <button className="next-button-wrapper" type="submit" onClick={handleApplyFilters}>
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadFilterOptions;